<template>
    <div v-loading="loading" class="main-width" style="display: flex;flex-wrap: wrap;padding-bottom: 38px;background-color: #ffffff">
        <div class="news_item notice_item" v-for="(item,index) in result.list" :key="index" :class="{'dottedline_css': (index - 11)%12 == 1 || (index > 11 && index%12 == 1) }" style="margin-top: 18px;" @click="goDetail(item.contentid)">
            <div class="news_item_cricle"></div>
            <div class="news_item_text" style="width: 400px">{{item.title}}</div>
            <div class="news_item_date">{{item.postDate}}</div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            loading: false,
            result: { list: [] }
        }
    },
    methods: {
    	//跳转到新闻详情
        goDetail: function(contentid) {
            this.$router.push({
                path: "/newsdetail",
                query: {
                    contentId: contentid
                }
            });
        },
        //获取通知公告
        getNotice: function() {
            let vue = this;
            return new Promise((resolve, reject) => {
                this.$axios.get("rrb-web/news/content/ext/list", { params: { pageNum: 1, pageSize: 10000, channelId: "162" } }).then(function(resp) {
                    if (resp.errcode == 0 || resp.errcode == "0") {
                        for (var i = 0; i < resp.data.dataList.length; i++) {
                            resp.data.dataList[i].postDate = resp.data.dataList[i].postDate ? resp.data.dataList[i].postDate.split(" ")[0] : "";
                        };
                        vue.result.list = resp.data.dataList;
                    };
                    resolve();
                }, function() {
                    resolve();
                });
            });
        },
    },
    mounted(){
    	var vue = this;
    	vue.loading = true;
    	this.getNotice().then(function(){
    		vue.loading = false;
    	});
    }
}
</script>